module.exports = __webpack_public_path__ + "img/cleanser_usage_frequency.6ced2abe.png";